import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"width":"100px"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 1,
  style: {"overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px","margin-bottom":"10px","line-height":"30px","margin-left":"5px"} }, " 示例：材积比167代表1CBM=167KGS，首行信息为仓库/堆场/码头中的默认选项 ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 关联服务 ", -1)
const _hoisted_15 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1)
const _hoisted_17 = { style: {"clear":"both"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_current_company_charge_form = _resolveComponent("current-company-charge-form")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_alert, {
      title: _ctx.tip,
      type: "warning",
      "show-icon": "",
      closable: false
    }, null, 8, ["title"]),
    _createVNode(_component_miezz_page_list, {
      modelValue: _ctx.list,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.list) = $event)),
      onHandleRowClick: _ctx.handleRowClick,
      onHandleGet: _ctx.handleGet,
      handle: ".drag-sort",
      onEnd: _ctx.hnadleDrop,
      onHandleTopButtonClick: _ctx.handleTopButtonClick,
      onHandleRowButtonClick: _ctx.handleRowButtonClick,
      onHandleBottomButtonClick: _ctx.handleBottomButtonClick
    }, {
      column: _withCtx(({ model, row }) => [
        (model.Prop == 'Type')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (row.Type == 10)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, "按重量计费"))
                : _createCommentVNode("", true),
              (row.Type == 20)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "按体积计费"))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (model.Prop == 'MinStandardPiece')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createTextVNode(_toDisplayString(row.MinStandardPiece) + " ", 1),
              (row.Type == 10)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "KGS"))
                : _createCommentVNode("", true),
              (row.Type == 20)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "CBM"))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (model.Prop == 'MinStandardTicket')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createTextVNode(_toDisplayString(row.MinStandardTicket) + " ", 1),
              (row.Type == 10)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "KGS"))
                : _createCommentVNode("", true),
              (row.Type == 20)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "CBM"))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (model.Prop == 'Services')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_ctx.isRelated==true)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.onServie(row)),
                    style: {"color":"#fe995b","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap","cursor":"pointer"}
                  }, _toDisplayString(_ctx.isString(row.Services)), 9, _hoisted_11))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.isString(row.Services)), 1))
            ]))
          : _createCommentVNode("", true)
      ]),
      defaultTip: _withCtx(() => [
        _hoisted_13
      ]),
      _: 1
    }, 8, ["modelValue", "onHandleRowClick", "onHandleGet", "onEnd", "onHandleTopButtonClick", "onHandleRowButtonClick", "onHandleBottomButtonClick"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalForm,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalForm) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_current_company_charge_form, {
          modelValue: _ctx.modalForm,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalForm) = $event)),
          companyId: _ctx.companyId,
          id: _ctx.id,
          onHandleSubmit: _ctx.handleSubmit
        }, null, 8, ["modelValue", "companyId", "id", "onHandleSubmit"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.serverForm != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.serverForm.Visiable,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.serverForm.Visiable) = $event)),
          "show-close": false,
          style: {"width":"40%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref: "refServiceForm",
              model: _ctx.serverForm
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "服务内容",
                  prop: "ServiceRemarks",
                  rules: [
                                    {
                                    required: true,
                                    message: '信息不能为空',
                                    trigger: 'change',
                                    },
                                ]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.serverForm.ServiceRemarks,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.serverForm.ServiceRemarks) = $event)),
                      multiple: "",
                      filterable: "",
                      placeholder: "请选择"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.Value,
                            label: item.Label,
                            value: item.Value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]),
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.serviceRemarkBottomButtons,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.serviceRemarkBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickServiceRemark
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}